/* tslint:disable */
import {
  Apptype,
  Tenant,
  App
} from '../index';

declare var Object: any;
export interface EntityInterface {
  custom: boolean;
  name: string;
  label: string;
  plural_label: string;
  vowel_start: boolean;
  description: string;
  parentId_onetoone: boolean;
  parentId_sortorder?: number;
  record_name: string;
  record_name_datatype: string;
  record_name_format: string;
  record_starting_number?: number;
  allow_reports: boolean;
  related_activities?: any;
  eventtriggers?: Array<any>;
  track_field_history: boolean;
  allow_sharing: boolean;
  allow_bulk_api_access: boolean;
  allow_streaming_api_access: boolean;
  deployment_status: string;
  allow_search: boolean;
  page_add_notes: boolean;
  lastupdatedby?: string;
  createdby?: string;
  id?: any;
  apptypeId?: any;
  tenantId?: any;
  appId?: any;
  parentId?: any;
  paastenantId?: any;
  createdAt: Date;
  updatedAt: Date;
  apptype?: Apptype;
  tenant?: Tenant;
  app?: App;
  parent?: Entity;
}

export class Entity implements EntityInterface {
  custom: boolean;
  name: string;
  label: string;
  plural_label: string;
  vowel_start: boolean;
  description: string;
  parentId_onetoone: boolean;
  parentId_sortorder: number;
  record_name: string;
  record_name_datatype: string;
  record_name_format: string;
  record_starting_number: number;
  allow_reports: boolean;
  related_activities: any;
  eventtriggers: Array<any>;
  track_field_history: boolean;
  allow_sharing: boolean;
  allow_bulk_api_access: boolean;
  allow_streaming_api_access: boolean;
  deployment_status: string;
  allow_search: boolean;
  page_add_notes: boolean;
  lastupdatedby: string;
  createdby: string;
  id: any;
  apptypeId: any;
  tenantId: any;
  appId: any;
  parentId: any;
  paastenantId: any;
  createdAt: Date;
  updatedAt: Date;
  apptype: Apptype;
  tenant: Tenant;
  app: App;
  parent: Entity;
  constructor(data?: EntityInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Entity`.
   */
  public static getModelName() {
    return "Entity";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Entity for dynamic purposes.
  **/
  public static factory(data: EntityInterface): Entity{
    return new Entity(data);
  }  
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Entity',
      plural: 'entities',
      properties: {
        custom: {
          name: 'custom',
          type: 'boolean',
          default: false
        },
        name: {
          name: 'name',
          type: 'string'
        },
        label: {
          name: 'label',
          type: 'string'
        },
        plural_label: {
          name: 'plural_label',
          type: 'string'
        },
        vowel_start: {
          name: 'vowel_start',
          type: 'boolean',
          default: false
        },
        description: {
          name: 'description',
          type: 'string'
        },
        parentId_onetoone: {
          name: 'parentId_onetoone',
          type: 'boolean',
          default: false
        },
        parentId_sortorder: {
          name: 'parentId_sortorder',
          type: 'number'
        },
        record_name: {
          name: 'record_name',
          type: 'string',
          default: 'name'
        },
        record_name_datatype: {
          name: 'record_name_datatype',
          type: 'string',
          default: 'text'
        },
        record_name_format: {
          name: 'record_name_format',
          type: 'string'
        },
        record_starting_number: {
          name: 'record_starting_number',
          type: 'number',
          default: 0
        },
        allow_reports: {
          name: 'allow_reports',
          type: 'boolean',
          default: false
        },
        related_activities: {
          name: 'related_activities',
          type: 'any',
          default: <any>null
        },
        eventtriggers: {
          name: 'eventtriggers',
          type: 'Array&lt;any&gt;',
          default: <any>[]
        },
        track_field_history: {
          name: 'track_field_history',
          type: 'boolean',
          default: false
        },
        allow_sharing: {
          name: 'allow_sharing',
          type: 'boolean',
          default: false
        },
        allow_bulk_api_access: {
          name: 'allow_bulk_api_access',
          type: 'boolean',
          default: false
        },
        allow_streaming_api_access: {
          name: 'allow_streaming_api_access',
          type: 'boolean',
          default: false
        },
        deployment_status: {
          name: 'deployment_status',
          type: 'string',
          default: 'dev'
        },
        allow_search: {
          name: 'allow_search',
          type: 'boolean',
          default: false
        },
        page_add_notes: {
          name: 'page_add_notes',
          type: 'boolean',
          default: false
        },
        lastupdatedby: {
          name: 'lastupdatedby',
          type: 'string',
          default: 'system'
        },
        createdby: {
          name: 'createdby',
          type: 'string',
          default: 'system'
        },
        id: {
          name: 'id',
          type: 'any'
        },
        apptypeId: {
          name: 'apptypeId',
          type: 'any'
        },
        tenantId: {
          name: 'tenantId',
          type: 'any'
        },
        appId: {
          name: 'appId',
          type: 'any'
        },
        parentId: {
          name: 'parentId',
          type: 'any'
        },
        paastenantId: {
          name: 'paastenantId',
          type: 'any'
        },
        createdAt: {
          name: 'createdAt',
          type: 'Date'
        },
        updatedAt: {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        apptype: {
          name: 'apptype',
          type: 'Apptype',
          model: 'Apptype'
        },
        tenant: {
          name: 'tenant',
          type: 'Tenant',
          model: 'Tenant'
        },
        app: {
          name: 'app',
          type: 'App',
          model: 'App'
        },
        parent: {
          name: 'parent',
          type: 'Entity',
          model: 'Entity'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/Entity.ts